/** Created by azhou on 2019/2/26.*/
<template>
  <div class="d-center-around">
    <rectangle-comp bgColor="#80C9CE">
      <h4>待处理订单</h4>
      <p @click="OrderHandle('1')">待核审：
        <span :class="{'text-danger':IndexData.pending_order_arr.verify_count>0}">{{IndexData.pending_order_arr.verify_count}}</span> 个
      </p>
      <p @click="OrderHandle('2')">待匹配：
        <span :class="{'text-danger':IndexData.pending_order_arr.match_count>0}">{{IndexData.pending_order_arr.match_count}}</span> 个
      </p>
      <p @click="OrderHandle('3')">待推送：
        <span :class="{'text-danger':IndexData.pending_order_arr.push_count>0}">{{IndexData.pending_order_arr.push_count}}</span> 个
      </p>
    </rectangle-comp>
    <rectangle-comp bgColor="#85B0E1">
      <h4>订单管理</h4>
      <p @click="goOrderLists('4')">询&ensp;价&ensp;中：
        <span :class="{'text-danger':IndexData.order_arr.status_4>0}">{{IndexData.order_arr.status_4}}</span> 个
      </p>
      <p @click="goOrderLists('7')">代&ensp;入&ensp;住：
        <span :class="{'text-danger':IndexData.order_arr.status_4>0}">{{IndexData.order_arr.status_7}}</span> 个
      </p>
      <p @click="goOrderLists('today')">今日入住：
        <span :class="{'text-danger':IndexData.order_arr.status_today>0}">{{IndexData.order_arr.status_today}}</span> 个</p>
      <p @click="goOrderLists('stay')">入&ensp;住&ensp;中：
        <span :class="{'text-danger':IndexData.order_arr.status_stay>0}">{{IndexData.order_arr.status_stay}}</span> 
        个
      </p>
      <p @click="$emit('goOrderLists',userInfo.type,'all','2')">
        未&ensp;支&ensp;付：
        <span :class="{'text-danger':IndexData.order_arr.wait_pay>0}">{{IndexData.order_arr.wait_pay}}</span> 个
      </p>
      <!-- <p  @click="$emit('goOrderLists',userInfo.type,'all','1')">已支付：<span>{{IndexData.order_arr.status_today}}</span> 个</p> -->
    </rectangle-comp>
    <rectangle-comp bgColor="#F8C26A">
      <h4>注册认证</h4>
      <p @click="goStoreLists(2)">采购商：<span :class="{'text-danger':IndexData.reg_verify_arr.travel_reg_count>0}">
        {{IndexData.reg_verify_arr.travel_reg_count}}</span> 个
      </p>
      <p @click="goStoreLists(3)">酒&ensp;&ensp;店：<span :class="{'text-danger':IndexData.reg_verify_arr.hotel_reg_count>0}">
        {{IndexData.reg_verify_arr.hotel_reg_count}}</span> 个
      </p>
    </rectangle-comp>
    <rectangle-comp bgColor="#b8a6d8">
      <h4>编辑认证</h4>
      <p @click="$router.push({name:'VerifyStoreCheck',query:{storeType:2}})">采购商：
        <span :class="{'text-danger':IndexData.edit_verify_arr.travel_edit_count>0}">{{IndexData.edit_verify_arr.travel_edit_count}}</span> 个
      </p>
      <p @click="$router.push({name:'VerifyStoreCheck',query:{storeType:3}})">酒&ensp;&ensp;店：
        <span :class="{'text-danger':IndexData.edit_verify_arr.hotel_edit_count>0}">{{IndexData.edit_verify_arr.hotel_edit_count}}</span> 个
      </p>
    </rectangle-comp>
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RectangleComp from './RectangleComp'

  export default {
    name: 'ACenter',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['storeInfo','userInfo'])
    },
    components: { RectangleComp },
    methods:{
      goStoreLists(type) {
        this.$router.push({name:'VerifyStore',query:{storeType:type}})
      },
      OrderHandle(type){
        this.$router.push({name:'OrderHandle',query:{page:1,orderStatus:type,orderType:3},num:'order'})
      },
      goOrderLists(type){
        this.$router.push({name:'OrderLists',query:{page:1,orderStatus:type,orderType:3},num:'order'})
      }
    }
  }
</script>
